import UserAvatar from "Areas/SharedFeatures/userAvatar";
import React from "react";
export default function ({ data, displayValue }) {
    return (displayValue && (React.createElement("div", { className: "grid-cols-auto with-gap-8" },
        React.createElement(UserAvatar, { size: 36, userId: data.Id, login: data.Login, firstName: data.FirstName, lastName: data.LastName, fullName: data.FullName, isParticipant: true }),
        React.createElement("div", { className: "flex-single-column d-inline-flex" },
            React.createElement("span", { className: "text-light-on-surface font-base" }, displayValue),
            React.createElement("span", { className: "text-light-on-surface-variant font-small" }, data.Name)))));
}
